import React from 'react';
import { WithT } from 'i18next';
import { IColumn, MuiCustomSwitch, UserPhoto } from 'components';
import { RoleTypes } from 'models';
import { IAdmin } from '../models';

export const generateAdminColumns = (t: WithT['t']): IColumn[] => {
	return [
		{
			name: 'name',
			label: <div>{t('table.name')}</div>,
			cellRenderer: (data: IAdmin) => {
				return (
					<div className="cell-content">
						<UserPhoto
							logoUrl={data.profilePictureUrl}
							logoClass="cell-content__icon cell-content__icon--with-name"
							placeholderClass="cell-content__icon cell-content__icon--with-name"
						/>
						<div className="cell-content__text">{`${data.firstName} ${data.lastName}`}</div>
					</div>
				);
			},
		},
		{
			name: 'email',
			label: <div>{t('table.email')}</div>,
			cellRenderer: (data: IAdmin) => {
				return <div>{data.email}</div>;
			},
		},
		{
			name: 'phone',
			label: <div>{t('table.phone')}</div>,
			cellRenderer: (data: IAdmin) => {
				return <div>{data.phone}</div>;
			},
		},
		{
			name: 'role',
			label: <div>{t('table.role')}</div>,
			cellRenderer: (data: IAdmin) => {
				return <div>{t(`common:${data.role.toLowerCase()}`)}</div>;
			},
		},
		{
			name: 'read_only',
			label: <div>{t('table.read_only')}</div>,
			cellRenderer: (data: IAdmin) => {
				if (data.role === RoleTypes.PRIMARY_ADMIN) {
					return null;
				}

				return (
					<MuiCustomSwitch
						value={data.role === RoleTypes.PARTNER_USER}
						handleChange={() => {}}
						disabled={true}
						disabledWithoutColors
					/>
				);
			},
		},
		// {
		// 	name: 'limit',
		// 	label: <div>{t('table.limit')}</div>,
		// 	cellRenderer: (data: IAdmin) => {
		// 		if (data.role !== RoleTypes.PARTNER_USER) {
		// 			return null;
		// 		}
		//
		// 		return (
		// 			<div className="cell-content">
		// 				<SettingsIcon
		// 					iconClass="cell-content__icon--small cell-content__icon--button"
		// 					onClick={() => console.log('settings clicked')}
		// 				/>
		// 			</div>
		// 		);
		// 	},
		// },
	];
};

export const generateAdminColumnsLimited = (t: WithT['t']): IColumn[] =>
	generateAdminColumns(t).slice(0, 4);
